import { render, staticRenderFns } from "./bidderFlow.vue?vue&type=template&id=3c90cad5&scoped=true"
import script from "./bidderFlow.vue?vue&type=script&lang=js"
export * from "./bidderFlow.vue?vue&type=script&lang=js"
import style0 from "./bidderFlow.vue?vue&type=style&index=0&id=3c90cad5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90cad5",
  null
  
)

export default component.exports